import { createRoute, lazyRouteComponent } from "@tanstack/react-router"
import { Route as RootRoute } from "../__root"

/**
 * Notifications inbox -- `/notifications`. Page body lazy-loaded.
 * Doesn't use any params, so no Route re-import in the page file.
 */
export const Route = createRoute({
	getParentRoute: () => RootRoute,
	path: "/notifications",
	component: lazyRouteComponent(() => import("./index.page")),
})
